(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!reduceMotion && 'IntersectionObserver' in window) {
    document.documentElement.classList.add('pq-motion');

    const revealObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 },
    );

    document.querySelectorAll('.pq-reveal').forEach((element) => revealObserver.observe(element));
  }

  class PikquaStickyPurchase extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      this.price = this.querySelector('[data-sticky-price]');
      this.productInfo = document.querySelector('product-info');

      if (!this.button || !this.productInfo) return;

      document.body.classList.add('pq-has-sticky-purchase');
      this.button.addEventListener('click', () => this.forwardSubmit());

      this.formObserver = new IntersectionObserver(
        ([entry]) => this.classList.toggle('is-visible', !entry.isIntersecting && window.scrollY > 320),
        { threshold: 0 },
      );

      const mainForm = this.productInfo.querySelector('product-form');
      if (mainForm) this.formObserver.observe(mainForm);

      this.syncObserver = new MutationObserver(() => this.syncState());
      this.syncObserver.observe(this.productInfo, { childList: true, subtree: true, attributes: true });
      this.syncState();
    }

    disconnectedCallback() {
      this.formObserver?.disconnect();
      this.syncObserver?.disconnect();
      document.body.classList.remove('pq-has-sticky-purchase');
    }

    getMainButton() {
      return this.productInfo?.querySelector('[id^="ProductSubmitButton-"]');
    }

    forwardSubmit() {
      const mainButton = this.getMainButton();
      if (mainButton && !mainButton.disabled) mainButton.click();
    }

    syncState() {
      const mainButton = this.getMainButton();
      const priceRoot = this.productInfo?.querySelector('[id^="price-"]');
      const visiblePrice =
        priceRoot?.querySelector('.price--on-sale .price-item--sale') ||
        priceRoot?.querySelector('.price-item--regular');

      if (visiblePrice && this.price) this.price.textContent = visiblePrice.textContent.trim();
      if (!mainButton) return;

      this.button.disabled = mainButton.disabled;
      const label = mainButton.querySelector('span')?.textContent?.trim();
      if (label) this.button.textContent = label;
    }
  }

  if (!customElements.get('pikqua-sticky-purchase')) {
    customElements.define('pikqua-sticky-purchase', PikquaStickyPurchase);
  }
})();
